function normalizeValue(value) {
  return value === undefined || value === null ? null : String(value)
}

export function isThesaurusIdValue(value) {
  return /^\d+$/.test(normalizeValue(value) || '')
}

export function getThesaurusRouteValue(theme) {
  if (theme && theme.id !== undefined && theme.id !== null) {
    return String(theme.id)
  }
  return theme ? theme.label : ''
}

export function matchesThesaurusValue(theme, value) {
  let normalizedValue = normalizeValue(value)
  if (!theme || normalizedValue === null) {
    return false
  }

  return normalizeValue(theme.id) === normalizedValue || theme.label === normalizedValue
}

export function findThesaurusPathByValue(themes, value, path = []) {
  if (!themes || value === undefined || value === null) {
    return null
  }

  for (let i = 0; i < themes.length; i++) {
    let theme = themes[i]
    let currentPath = [...path, theme]

    if (matchesThesaurusValue(theme, value)) {
      return currentPath
    }

    let childPath = findThesaurusPathByValue(theme.subThemes, value, currentPath)
    if (childPath) {
      return childPath
    }
  }

  return null
}

export function findThesaurusNodeByValue(themes, value) {
  let path = findThesaurusPathByValue(themes, value)
  return path ? path[path.length - 1] : null
}

export function resolveThesaurusLabel(themes, value) {
  let match = findThesaurusNodeByValue(themes, value)
  return match ? match.label : value
}

export function collectSubthemesForThemes(themes, selectedThemeValue) {
  if (!themes || !selectedThemeValue) {
    return null
  }

  let subthemes = []
  let ids = selectedThemeValue.split(',')

  ids.forEach(themeValue => {
    let theme = findThesaurusNodeByValue(themes, themeValue)
    if (theme && theme.subThemes) {
      subthemes.push(...theme.subThemes)
    }
  })

  let uniqueSubthemes = new Map()
  subthemes.forEach(subtheme => {
    uniqueSubthemes.set(getThesaurusRouteValue(subtheme), subtheme)
  })

  return [...uniqueSubthemes.values()]
}

export function findDetailsForSubtheme(themes, selectedThemeValue, selectedSubthemeValue) {
  let subthemes = collectSubthemesForThemes(themes, selectedThemeValue)
  if (!subthemes || !selectedSubthemeValue) {
    return null
  }

  let subtheme = findThesaurusNodeByValue(subthemes, selectedSubthemeValue)
  if (!subtheme || !subtheme.subThemes || subtheme.subThemes.length === 0) {
    return null
  }

  return subtheme.subThemes
}
